import api from "./http";

export const insertStudent = async (studentData) => {
  try {
    const response = await api.post(`/students/create-student`, studentData);
    return response.data;
  } catch (error) {
    console.error("Error inserting student data:", error);
    return error.message;
  }
};

export const getStudentsList = async (academicYear = null) => {
  try {
    const params = academicYear ? { academicYear } : {};
    const response = await api.get(`/students/list`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching students list:", error);
    return error.message;
  }
};

// Convenience helper to fetch one student by id by filtering the list
export const getStudentById = async (studentId, academicYear = null) => {
  try {
    const params = academicYear ? { academicYear } : {};
    const response = await api.get(`/students/${studentId}`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching student by id:", error);
    return { error: error.response?.data?.message || error.message };
  }
};

// Update student - requires backend support. Endpoint is a placeholder.
export const updateStudent = async (studentId, studentData) => {
  try {
    const response = await api.put(`/students/${studentId}`, studentData);
    return response.data;
  } catch (error) {
    console.error("Error updating student data:", error);
    return {
      error:
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message,
      code: error.response?.data?.code,
      blockedFields: error.response?.data?.blockedFields,
    };
  }
};

export const inactivateStudent = async (studentId) => {
  try {
    const response = await api.put(`/students/inactivate/${studentId}`);
    return response.data;
  } catch (error) {
    console.error("Error inactivating student:", error);
    return { error: error.response?.data?.message || error.message };
  }
};

export const validateAdmissionNo = async (admissionNo) => {
  try {
    const response = await api.get(`/validate-admission-no`, {
      params: { admissionNo }
    });
    return response.data;
  } catch (error) {
    console.error("Error validating admission number:", error);
    return { error: error.response?.data?.error || error.message };
  }
};

// Upload student profile photo
export const uploadStudentPhoto = async (studentId, file) => {
  try {
    const formData = new FormData();
    formData.append("photo", file);

    const response = await api.post(`/upload/student/${studentId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error uploading student photo:", error);
    return { error: error.response?.data?.error || error.message };
  }
};

// Delete student profile photo
export const deleteStudentPhoto = async (studentId) => {
  try {
    const response = await api.delete(`/upload/student/${studentId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting student photo:", error);
    return { error: error.response?.data?.error || error.message };
  }
};
